import { Portal } from '@radix-ui/react-dialog';

export const ModalPortal = Portal;
